module.exports = "9f2a0c0e7582d9e8dff5a0ceea72e4f7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/spike-edge-L.png
// module id = 42
// module chunks = 0